document.addEventListener("turbolinks:load", function () {
    const assignmentTitle =  document.querySelector("#assignment-title");
    const assignmentTitleError =  document.querySelector("#assignment-title-error");
    const activityList = document.querySelector("#activity-list");
    const saveButton = document.querySelector(".save-changes-button");

    // Determine if this is the correct page by finding specific elements
    if (saveButton && assignmentTitle) {
        const toggleNext = () => {
            toggleVbButton(saveButton);
        }
        // Assignment Title Validation
        assignmentTitle.addEventListener("blur", () => {
            // If the string is empty or only white space, show the error. Otherwise hide it
            assignmentTitle.value.trim() === "" ? showVbError(assignmentTitleError) : hideVbError(assignmentTitleError);
            toggleNext();
        });
        // Activity Card Validation Setup
        setUpActivityCard(activityList, toggleNext);
    }
})